(function () {
  const outingSeriesScoresSummaryReport = function () {
    const changeOffLabel = (elem, value) => {
      var label = elem.parent().find(".bootstrap-switch-label");
      label.text(value ? $(elem).attr("data-on-text") : $(elem).attr("data-off-text"));
    };

    const changeToggleLabels = (elemTarget) => {
      $(elemTarget).hide();
      setTimeout(function () {
        $(elemTarget).each(function () {
          const target = this;
          $(this).bootstrapSwitch("state", $(this).attr("checked"));
          $(this).on("switchChange.bootstrapSwitch", function (_, state) {
            const hiddenInput = $(target).parent().parent().parent().find("input[type=hidden]");
            hiddenInput.val(state ? $(this).attr("data-on-value") : $(this).attr("data-off-value"));
            changeOffLabel($(target), !state);
            setTimeout(function () {
              $($(target)[0].form).trigger("submit");
            }, 300);
          });
          changeOffLabel($(target), !$(this).prop("checked"));
        });
      }, 300);
    };

    const init = () => {
      const targets = ["input.scores-type-toggle", "input.diff-type-toggle"];
      for (let i = 0; i < targets.length; i++) {
        changeToggleLabels(targets[i]);
      }
    };

    $(document).on("turbolinks:load", () => {
      if (
        !$("body").hasClass("controller-outings-reports-scores") &&
        !$("body").hasClass("controller-outings-reports-tie_breakers") &&
        !$("body").hasClass("controller-outings-series-reports-scores_summary")
      )
        return;

      init();
    });
  };

  if (typeof window !== "undefined") {
    window.outingSeriesScoresSummaryReport = outingSeriesScoresSummaryReport();
  }
})();
